// extracted by mini-css-extract-plugin
module.exports = {"dateCarousel":"DateCarousel_dateCarousel__bJ05y","dateChip":"DateCarousel_dateChip__wF_au","active":"DateCarousel_active__rk6DA"};